import factory from './icon';
import Svg from './Glyphs/something_went_wrong.svg';

export default factory(Svg, 24, 24);
